// import React, { useState, useRef, useEffect } from 'react';
// import { apiCall } from '@/api/apiCall';
// import { toast } from 'sonner';
// import { useApiQueue } from '@/hooks/useApiQueue';
// import AlHassa from '@/assets/img/AlHassa.png';
// import OnStreet from '@/assets/img/TaifContract-onStreet.png';
// import Enforcement from '@/assets/img/TaifContract-Enforcement.png';
// import { AssetsPanel } from '../../components/shared/AssetsPanel';
// import { API_CALL_TIME } from '@/constants/constant';


// // ═══════════════════════════════════════════════════════════════════════
// // HELPERS
// // ═══════════════════════════════════════════════════════════════════════
// const groupsToFlat = (groups = []) => {
//   const result = [];
//   groups.forEach(g => {
//     result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
//     (g.items || []).forEach(item => {
//       result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
//     });
//   });
//   return result;
// };

// const flatToGroups = (flat) => {
//   const groups = [];
//   let cur = null;
//   flat.forEach(a => {
//     if (a.isCategory) {
//       if (cur) groups.push(cur);
//       cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
//     } else if (cur) {
//       cur.items.push({ item_name: a.name, qty: a.subCount || '' });
//     }
//   });
//   if (cur) groups.push(cur);
//   return groups;
// };

// // ═══════════════════════════════════════════════════════════════════════
// // ASSET GROUPS HELPER
// // ═══════════════════════════════════════════════════════════════════════
// function makeAssetGroups(o = {}) {
//   return [
//     { group_name: 'Ticket Dispenser',    group_total_qty: o.ticketDispenser ?? '-', items: [{ item_name: 'DIP G100', qty: '-' }, { item_name: 'G100 64 Bit', qty: '-' }, { item_name: 'G100 32 Bit', qty: '-' }] },
//     { group_name: 'Ticket Verifier',     group_total_qty: o.ticketVerifier  ?? '-', items: [{ item_name: 'EV DIP G100', qty: '-' }, { item_name: 'EV G100 64 Bit', qty: o.evG10064 ?? '-' }, { item_name: 'EV G100 32 Bit', qty: '-' }] },
//     { group_name: "APM's",               group_total_qty: o.apms            ?? '-', items: [{ item_name: 'APM ETS-70', qty: '-' }, { item_name: 'APM ETS-100', qty: '-' }] },
//     { group_name: 'PIN Pad',             group_total_qty: o.pinPad          ?? '-', items: [{ item_name: 'IUP250', qty: '-' }] },
//     { group_name: 'Card Reader',         group_total_qty: o.cardReader      ?? '-', items: [{ item_name: 'IUR250', qty: '-' }] },
//     { group_name: 'B-Contactless',       group_total_qty: o.bContactless    ?? '-', items: [{ item_name: 'IUC150', qty: '-' }] },
//     { group_name: 'RFID Reader',         group_total_qty: o.rfidReader      ?? '-', items: [] },
//     { group_name: 'IP Barrier',          group_total_qty: o.ipBarrier       ?? '-', items: [] },
//     { group_name: 'ANPR CAMERA',         group_total_qty: o.anprCamera      ?? '-', items: [{ item_name: 'ARH', qty: o.arh ?? '-' }, { item_name: 'Luminera', qty: '-' }] },
//     { group_name: 'Sliding Gate',        group_total_qty: o.slidingGate     ?? '-', items: [{ item_name: 'RIGHT', qty: '-' }, { item_name: 'LEFT', qty: '-' }] },
//     { group_name: "PND's",               group_total_qty: o.pnds            ?? '-', items: [{ item_name: 'TPAL- BNA Large', qty: o.tpalBna ?? '-' }, { item_name: 'T-PAL TX', qty: o.tpalTx ?? '-' }, { item_name: 'T-PAL V2', qty: o.tpalV2 ?? '-' }] },
//     { group_name: 'Pound Cahier Device', group_total_qty: '-',                      items: [{ item_name: 'CN-50', qty: '-' }] },
//     { group_name: 'Driver Device',       group_total_qty: '-',                      items: [{ item_name: 'CN-51', qty: '-' }] },
//     { group_name: 'Enf Device',          group_total_qty: o.enfDevice       ?? '-', items: [{ item_name: 'Oukitel WP2', qty: o.oukitel ?? '-' }, { item_name: 'Doogee V10', qty: o.doogee ?? '-' }] },
//     { group_name: 'Validation',          group_total_qty: '-',                      items: [{ item_name: 'Lenova Tablet', qty: '-' }] },
//     { group_name: 'Printer',             group_total_qty: o.printer         ?? '-', items: [{ item_name: 'PR-3', qty: o.pr3 ?? '-' }, { item_name: 'SEWOO', qty: o.sewoo ?? '-' }, { item_name: 'BIXOLON', qty: o.bixolon ?? '-' }] },
//     { group_name: 'Tow Truck',           group_total_qty: o.towTruck        ?? '-', items: [] },
//     { group_name: 'Clamp Vehicle',       group_total_qty: o.clampVehicle    ?? '-', items: [] },
//     { group_name: 'Support Vehicle',     group_total_qty: o.supportVehicle  ?? '-', items: [] },
//   ];
// }

// // ═══════════════════════════════════════════════════════════════════════
// // CONFIG
// // ═══════════════════════════════════════════════════════════════════════
// const ALHASSA_PROFILE_CONFIG = {

//   alhassa_on_street_profile: {
//     profileKey:   'alhassa_on_street_profile',
//     tariffKey:    'alhassa_on_street_tariff',
//     assetsKey:    'alhassa_on_street_assets',
//     pageType:     'on_street',

//     profileFallback: {
//       table_key: 'alhassa_on_street_profile',
//       title: 'Al Hassa On Street - Profile',
//       data: {
//         total_bays:      { label: 'Total On-Street Parking Bays', value: '2,489' },
//         contract_term:   { value: '14 years' },
//         contract_period: { start_date: '23.02.2016', end_date: '12.09.2030' },
//         rate_per_hour:   { value: 'as per below table' },
//       },
//     },

//     tariffFallback: {
//       table_key: 'alhassa_on_street_tariff',
//       title: 'On Street Parking Tariff excluding Vat 15%',
//       data: {
//         rows: [
//           {
//             product:      'Al Hassa On street Parking',
//             vehicle_type: 'Any',
//             tariff:       '02 SAR',
//             timing:       '08:00 AM - 12:00 PM\n04:00 PM - 10:00 PM',
//             working_days: 'Friday Off',
//           },
//         ],
//       },
//     },

//     assetsFallback: {
//       table_key: 'alhassa_on_street_assets',
//       title: 'Hassa On Street',
//       data: {
//         groups: makeAssetGroups({
//           ticketDispenser: '-', ticketVerifier: '1', evG10064: '1',
//           apms: '-', pinPad: '-', cardReader: '-', bContactless: '-',
//           rfidReader: '3', ipBarrier: '2', anprCamera: '-', arh: '-',
//           slidingGate: '-',
//           pnds: '182', tpalBna: '60', tpalTx: '106', tpalV2: '16',
//           enfDevice: '37', oukitel: '27', doogee: '10',
//           printer: '35', pr3: '15', sewoo: '11', bixolon: '9',
//           towTruck: '3', clampVehicle: '2', supportVehicle: '1',
//         }),
//       },
//     },
//   },
// };


// // ═══════════════════════════════════════════════════════════════════════
// // MAIN COMPONENT
// // ═══════════════════════════════════════════════════════════════════════
// const AlHassaProfile = ({ page, year = '', monthNumber = '', contract = '' }) => {
//   const cfg = ALHASSA_PROFILE_CONFIG[page?.type];
//   if (!cfg) return null;

//   const hasFetchedRef = useRef(false);
//   const saveRef       = useRef(null);
//   const [isSaving, setIsSaving]         = useState(false);
//   const [profileTable, setProfileTable] = useState(cfg.profileFallback);
//   const [assetsTable, setAssetsTable]   = useState(cfg.assetsFallback);
//   const [tariffTable, setTariffTable]   = useState(cfg.tariffFallback);
//   const { enqueue } = useApiQueue();

//   // ── Refs for latest state (Stale State Fix) ─────────────────────────────
//   const profileRef = useRef(null);
//   const assetsRef  = useRef(null);
//   const tariffRef  = useRef(null);

//   // Sync refs with latest state
//   useEffect(() => { profileRef.current = profileTable; }, [profileTable]);
//   useEffect(() => { assetsRef.current  = assetsTable;  }, [assetsTable]);
//   useEffect(() => { tariffRef.current  = tariffTable;  }, [tariffTable]);

//   // ── Fetch ─────────────────────────────────────────────────────────────
//   useEffect(() => {
//     if (hasFetchedRef.current) return;
//     hasFetchedRef.current = true;
//     fetchData();
//   }, [year, monthNumber, contract]);

//   const fetchData = async () => {
//     try {
//       const res = await enqueue(() => apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber }));
//       if (!res?.success) return;
//       const data = res?.data || [];
//       const find = (key, fb) => data.find(t => t.table_key === key) || fb;

//       setProfileTable(find(cfg.profileKey, cfg.profileFallback));
//       setAssetsTable(find(cfg.assetsKey, cfg.assetsFallback));
//       setTariffTable(find(cfg.tariffKey, cfg.tariffFallback));
//     } catch (err) {
//       console.error('Fetch error:', err);
//     }
//   };

//   // ── Auto-save ─────────────────────────────────────────────────────────
//   const autoSave = () => {
//     if (saveRef.current) clearTimeout(saveRef.current);
//     saveRef.current = setTimeout(saveToAPI, API_CALL_TIME);
//   };

//     // ── Fixed saveToAPI using Refs ────────────────────────────────────────────
//   const saveToAPI = async () => {
//     try {
//       setIsSaving(true);

//       const tables = [
//         { 
//           table_key: profileRef.current?.table_key, 
//           title: profileRef.current?.title, 
//           data: profileRef.current?.data 
//         },
//         { 
//           table_key: assetsRef.current?.table_key, 
//           title: assetsRef.current?.title, 
//           data: assetsRef.current?.data 
//         },
//       ];

//       if (tariffRef.current) {
//         tables.push({ 
//           table_key: tariffRef.current.table_key, 
//           title: tariffRef.current.title, 
//           data: tariffRef.current.data 
//         });
//       }

//       const res = await apiCall('POST', '/boardpack/add-tables-data', {
//         contract, 
//         year, 
//         month: monthNumber, 
//         created_by: 1, 
//         tables,
//       });

//       if (!res?.success) throw new Error(res?.message || 'Save failed');
//     } catch (err) {
//       console.error('Save error:', err);
//       toast.error('Failed to save changes');
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   // ── Patch helpers ─────────────────────────────────────────────────────
//   const patchProfile = (field, subField, value) => {
//     setProfileTable(prev => ({
//       ...prev,
//       data: { ...prev.data, [field]: subField ? { ...prev.data[field], [subField]: value } : value },
//     }));
//     autoSave();
//   };

//   const handleTariffCell = (rIdx, key, value) => {
//     setTariffTable(prev => ({
//       ...prev,
//       data: { ...prev.data, rows: prev.data.rows.map((r, i) => i === rIdx ? { ...r, [key]: value } : r) },
//     }));
//     autoSave();
//   };

//   const handleAssetSubCount = (flatIdx, value) => {
//     const flat = groupsToFlat(assetsTable.data.groups).map((a, i) => i === flatIdx ? { ...a, subCount: value } : a);
//     setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
//     autoSave();
//   };

//   const handleAssetTotalCount = (flatIdx, value) => {
//     const flat = groupsToFlat(assetsTable.data.groups).map((a, i) => i === flatIdx ? { ...a, totalCount: value } : a);
//     setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
//     autoSave();
//   };

//   const pd         = profileTable.data;
//   const flatAssets = groupsToFlat(assetsTable.data.groups);

//   // ═══════════════════════════════════════════════════════════════════
//   // RENDER
//   // ═══════════════════════════════════════════════════════════════════
//   return (
//     <div className="min-h-screen p-4 md:p-6 lg:p-8 bg-white">

//       {/* ── Header ── */}
//       <div className="flex justify-between items-center mb-3">
//         <div className="ml-2">
//           <img src={AlHassa} alt="Al Hassa Logo" style={{ height: '50px', objectFit: 'contain' }} />
//         </div>
//         <h1 className="text-xl font-bold flex-1 text-center">{profileTable.title}</h1>
//       </div>

//       <div className="flex flex-col lg:flex-row gap-0 !border-2 !border-black p-3">

//         {/* ══ LEFT ══ */}
//         <div className="flex-1 pr-4">
//           <div className="flex flex-col">

//             {/* ── Activities ── */}
//            <div className="mb-4">
//                         <div className="text-[16px] font-semibold mb-4">Activities:</div>
//                         <div className="flex gap-4 justify-start ml-16 ">
//                           {['On Street', , 'Enforcement'].map(label => (
//                             <div key={label} className="flex flex-col items-center gap-2 ">
//                               {label === 'On Street' && <img src={OnStreet} alt="Bab Al Ree Logo" style={{ height: '150px', objectFit: 'contain' }} />}
//                               {label === 'Enforcement' && <img src={Enforcement} alt="Bab Al Ree Logo" style={{ height: '150px', objectFit: 'contain' }} />}
//                             </div>
          
          
//                           ))}
//                         </div>
//                       </div>

//             {/* ── Profile Info ── */}
//             <div className="flex flex-col gap-1 mb-2">

//               {/* Total Bays */}
//               <div className="flex items-center gap-2">
//                 <div className="w-3 h-3   rounded flex items-center justify-center text-[8px] text-gray-400 " />
//                                   <img src={OnStreet} alt="On Street" style={{ height: '50px', objectFit: 'contain' }} />
                
//                 <span className="text-[12px]">
//                   {pd.total_bays?.label}{' '}
//                   <strong>
//                     <input type="text" value={pd.total_bays?.value || ''}
//                       onChange={e => patchProfile('total_bays', 'value', e.target.value)}
//                       className="font-bold outline-none bg-transparent !border-0 text-[12px] w-20" />
//                   </strong>
//                 </span>
//               </div>

//               {/* Contract Term */}
//               <div className="flex items-center gap-2 ml-20">
//                 <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                 <span className="text-[12px] flex items-center flex-wrap gap-1">
//                   Contract term{' '}
//                   <strong><input type="text" value={pd.contract_term?.value || ''}
//                     onChange={e => patchProfile('contract_term', 'value', e.target.value)}
//                     className="font-bold outline-none bg-transparent !border-0 text-[12px] w-12" /></strong>
//                   ; start date{' '}
//                   <strong><input type="text" value={pd.contract_period?.start_date || ''}
//                     onChange={e => patchProfile('contract_period', 'start_date', e.target.value)}
//                     className="font-bold outline-none bg-transparent !border-0 text-[12px] w-18" /></strong>
//                   {' to '}
//                   <strong><input type="text" value={pd.contract_period?.end_date || ''}
//                     onChange={e => patchProfile('contract_period', 'end_date', e.target.value)}
//                     className="font-bold outline-none bg-transparent !border-0 text-[12px] w-24" /></strong>
//                 </span>
//               </div>

//               {/* Rate Per Hour */}
//               <div className="flex items-center gap-2 ml-20">
//                 <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                 <span className="text-[12px]">
//                   Rate per Hour{' '}
//                   <strong>
//                     <input type="text" value={pd.rate_per_hour?.value || ''}
//                       onChange={e => patchProfile('rate_per_hour', 'value', e.target.value)}
//                       className="font-bold outline-none bg-transparent !border-0 text-[12px] w-48" />
//                   </strong>
//                 </span>
//               </div>

//               {/* Assets Deployed */}
//               <div className="flex items-center gap-2 ml-20">
//                 <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
//                 <span className="text-[12px]">Assets Deployed</span>
//               </div>
//             </div>

//           </div>

//           {/* ── Tariff Table ── */}
//           {tariffTable && (
//             <div className="mt-2">
//               <table className="!border-collapse text-[8px]">
//                 <thead>
//                   <tr>
//                     <th colSpan={5} className="!border !border-black px-2 py-1.5 bg-gray-300 text-center font-bold text-[11px]">
//                       {tariffTable.title}
//                     </th>
//                   </tr>
//                   <tr className="bg-gray-300">
//                     {[
//                       { label: 'Product',      w: '180px' },
//                       { label: 'Vehicle Type', w: '80px'  },
//                       { label: 'Tariff',       w: '60px'  },
//                       { label: 'Timing',       w: '150px' },
//                       { label: 'Working Days', w: '90px'  },
//                     ].map(({ label, w }) => (
//                       <th key={label} className="!border !border-black px-2 py-1 font-bold text-center" style={{ minWidth: w }}>
//                         {label}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {tariffTable.data.rows.map((row, rIdx) => (
//                     <tr key={rIdx} className={rIdx % 2 === 0 ? 'bg-white' : ''}>
//                       {[
//                         { key: 'product',      w: '180px' },
//                         { key: 'vehicle_type', w: '80px'  },
//                         { key: 'tariff',       w: '60px'  },
//                         { key: 'timing',       w: '150px' },
//                         { key: 'working_days', w: '90px'  },
//                       ].map(({ key, w }) => (
//                         <td key={key} className="!border !border-black px-1 py-0.5">
//                           <textarea
//                             value={row[key] || ''}
//                             onChange={e => handleTariffCell(rIdx, key, e.target.value)}
//                             className="!border-0 bg-transparent outline-none text-[9px] content-center resize-none text-center"
//                             style={{ width: w, minHeight: '30px' }}
//                             rows={2}
//                           />
//                         </td>
//                       ))}
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </div>

//         {/* ══ RIGHT — Assets Panel ══ */}
//         <AssetsPanel
//           assetsTable={assetsTable}
//           flatAssets={flatAssets}
//           onSubCount={handleAssetSubCount}
//           onTotalCount={handleAssetTotalCount}
//         />
//       </div>

//       {/* {isSaving && (
//         <div className="fixed bottom-4 right-4 bg-blue-600 text-white text-xs px-3 py-1.5 rounded shadow-lg z-50">
//           Saving...
//         </div>
//       )} */}
//     </div>
//   );
// };

// export default AlHassaProfile;











import React, { useState, useRef, useEffect } from 'react';
import { apiCall } from '@/api/apiCall';
import { toast } from 'sonner';
import { useApiQueue } from '@/hooks/useApiQueue';
import AlHassa from '@/assets/img/AlHassa.png';
import OnStreet from '@/assets/img/TaifContract-onStreet.png';
import Enforcement from '@/assets/img/TaifContract-Enforcement.png';
import { AssetsPanel } from '../../components/shared/AssetsPanel';
import { API_CALL_TIME } from '@/constants/constant';


// ═══════════════════════════════════════════════════════════════════════
// HELPERS
// ═══════════════════════════════════════════════════════════════════════
const groupsToFlat = (groups = []) => {
  const result = [];
  groups.forEach(g => {
    result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
    (g.items || []).forEach(item => {
      result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
    });
  });
  return result;
};

const flatToGroups = (flat) => {
  const groups = [];
  let cur = null;
  flat.forEach(a => {
    if (a.isCategory) {
      if (cur) groups.push(cur);
      cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
    } else if (cur) {
      cur.items.push({ item_name: a.name, qty: a.subCount || '' });
    }
  });
  if (cur) groups.push(cur);
  return groups;
};

// ═══════════════════════════════════════════════════════════════════════
// ASSET GROUPS HELPER
// ═══════════════════════════════════════════════════════════════════════
function makeAssetGroups(o = {}) {
  return [
    { group_name: 'Ticket Dispenser',    group_total_qty: o.ticketDispenser ?? '-', items: [{ item_name: 'DIP G100', qty: '-' }, { item_name: 'G100 64 Bit', qty: '-' }, { item_name: 'G100 32 Bit', qty: '-' }] },
    { group_name: 'Ticket Verifier',     group_total_qty: o.ticketVerifier  ?? '-', items: [{ item_name: 'EV DIP G100', qty: '-' }, { item_name: 'EV G100 64 Bit', qty: o.evG10064 ?? '-' }, { item_name: 'EV G100 32 Bit', qty: '-' }] },
    { group_name: "APM's",               group_total_qty: o.apms            ?? '-', items: [{ item_name: 'APM ETS-70', qty: '-' }, { item_name: 'APM ETS-100', qty: '-' }] },
    { group_name: 'PIN Pad',             group_total_qty: o.pinPad          ?? '-', items: [{ item_name: 'IUP250', qty: '-' }] },
    { group_name: 'Card Reader',         group_total_qty: o.cardReader      ?? '-', items: [{ item_name: 'IUR250', qty: '-' }] },
    { group_name: 'B-Contactless',       group_total_qty: o.bContactless    ?? '-', items: [{ item_name: 'IUC150', qty: '-' }] },
    { group_name: 'RFID Reader',         group_total_qty: o.rfidReader      ?? '-', items: [] },
    { group_name: 'IP Barrier',          group_total_qty: o.ipBarrier       ?? '-', items: [] },
    { group_name: 'ANPR CAMERA',         group_total_qty: o.anprCamera      ?? '-', items: [{ item_name: 'ARH', qty: o.arh ?? '-' }, { item_name: 'Luminera', qty: '-' }] },
    { group_name: 'Sliding Gate',        group_total_qty: o.slidingGate     ?? '-', items: [{ item_name: 'RIGHT', qty: '-' }, { item_name: 'LEFT', qty: '-' }] },
    { group_name: "PND's",               group_total_qty: o.pnds            ?? '-', items: [{ item_name: 'TPAL- BNA Large', qty: o.tpalBna ?? '-' }, { item_name: 'T-PAL TX', qty: o.tpalTx ?? '-' }, { item_name: 'T-PAL V2', qty: o.tpalV2 ?? '-' }] },
    { group_name: 'Pound Cahier Device', group_total_qty: '-',                      items: [{ item_name: 'CN-50', qty: '-' }] },
    { group_name: 'Driver Device',       group_total_qty: '-',                      items: [{ item_name: 'CN-51', qty: '-' }] },
    { group_name: 'Enf Device',          group_total_qty: o.enfDevice       ?? '-', items: [{ item_name: 'Oukitel WP2', qty: o.oukitel ?? '-' }, { item_name: 'Doogee V10', qty: o.doogee ?? '-' }] },
    { group_name: 'Validation',          group_total_qty: '-',                      items: [{ item_name: 'Lenova Tablet', qty: '-' }] },
    { group_name: 'Printer',             group_total_qty: o.printer         ?? '-', items: [{ item_name: 'PR-3', qty: o.pr3 ?? '-' }, { item_name: 'SEWOO', qty: o.sewoo ?? '-' }, { item_name: 'BIXOLON', qty: o.bixolon ?? '-' }] },
    { group_name: 'Tow Truck',           group_total_qty: o.towTruck        ?? '-', items: [] },
    { group_name: 'Clamp Vehicle',       group_total_qty: o.clampVehicle    ?? '-', items: [] },
    { group_name: 'Support Vehicle',     group_total_qty: o.supportVehicle  ?? '-', items: [] },
  ];
}

// ═══════════════════════════════════════════════════════════════════════
// CONFIG
// ═══════════════════════════════════════════════════════════════════════
const ALHASSA_PROFILE_CONFIG = {

  alhassa_on_street_profile: {
    profileKey:   'alhassa_on_street_profile',
    tariffKey:    'alhassa_on_street_tariff',
    assetsKey:    'alhassa_on_street_assets',
    pageType:     'on_street',

    profileFallback: {
      table_key: 'alhassa_on_street_profile',
      title: 'Al Hassa On Street - Profile',
      data: {
        total_bays:      { label: 'Total On-Street Parking Bays', value: '2,489' },
        contract_term:   { value: '14 years' },
        contract_period: { start_date: '23.02.2016', end_date: '12.09.2030' },
        rate_per_hour:   { value: 'as per below table' },
      },
    },

    tariffFallback: {
      table_key: 'alhassa_on_street_tariff',
      title: 'On Street Parking Tariff excluding Vat 15%',
      data: {
        rows: [
          {
            product:      'Al Hassa On street Parking',
            vehicle_type: 'Any',
            tariff:       '02 SAR',
            timing:       '08:00 AM - 12:00 PM\n04:00 PM - 10:00 PM',
            working_days: 'Friday Off',
          },
        ],
      },
    },

    assetsFallback: {
      table_key: 'alhassa_on_street_assets',
      title: 'Hassa On Street',
      data: {
        groups: makeAssetGroups({
          ticketDispenser: '-', ticketVerifier: '1', evG10064: '1',
          apms: '-', pinPad: '-', cardReader: '-', bContactless: '-',
          rfidReader: '3', ipBarrier: '2', anprCamera: '-', arh: '-',
          slidingGate: '-',
          pnds: '182', tpalBna: '60', tpalTx: '106', tpalV2: '16',
          enfDevice: '37', oukitel: '27', doogee: '10',
          printer: '35', pr3: '15', sewoo: '11', bixolon: '9',
          towTruck: '3', clampVehicle: '2', supportVehicle: '1',
        }),
      },
    },
  },
};


// ═══════════════════════════════════════════════════════════════════════
// MAIN COMPONENT
// ═══════════════════════════════════════════════════════════════════════
const AlHassaProfile = ({ page, year = '', month = '', monthNumber = '', contract = '' }) => {
  const cfg = ALHASSA_PROFILE_CONFIG[page?.type];
  if (!cfg) return null;

  const hasFetchedRef = useRef(false);
  const saveRef       = useRef(null);
  const [isSaving, setIsSaving]         = useState(false);
  
  // 🔥 State for second API (parking bays)
  const [parkingBaysData, setParkingBaysData] = useState(null);
  
  const [profileTable, setProfileTable] = useState(cfg.profileFallback);
  const [assetsTable, setAssetsTable]   = useState(cfg.assetsFallback);
  const [tariffTable, setTariffTable]   = useState(cfg.tariffFallback);
  const { enqueue } = useApiQueue();

  // 🔥 Effective total bays - second API se aayega
  const effectiveTotalBays = parkingBaysData?.total_bays ?? profileTable?.data?.total_bays?.value ?? '0';

  // ── Refs for latest state (Stale State Fix) ─────────────────────────────
  const profileRef = useRef(null);
  const assetsRef  = useRef(null);
  const tariffRef  = useRef(null);

  // Sync refs with latest state
  useEffect(() => { profileRef.current = profileTable; }, [profileTable]);
  useEffect(() => { assetsRef.current  = assetsTable;  }, [assetsTable]);
  useEffect(() => { tariffRef.current  = tariffTable;  }, [tariffTable]);

  // ── Fetch BOTH APIs ─────────────────────────────────────────────────────────────
  useEffect(() => {
    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;
    fetchAllData();
  }, [year, month, monthNumber, contract]);

  const fetchAllData = async () => {
    try {
      // 🔥 Second API params
      const secondApiParams = {
        contract: "0030006",
        year: year,
        month: month,
        device_onstreet: "HAS",
        type: "on_street"
      };
      
      const [firstApiResponse, secondApiResponse] = await Promise.all([
        enqueue(() => apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber })),
        enqueue(() => apiCall('GET', '/boardpack/parking/bays', secondApiParams))
      ]);

      // Process first API response
      if (firstApiResponse?.success) {
        const data = firstApiResponse?.data || [];
        const find = (key, fb) => data.find(t => t.table_key === key) || fb;

        setProfileTable(find(cfg.profileKey, cfg.profileFallback));
        setAssetsTable(find(cfg.assetsKey, cfg.assetsFallback));
        setTariffTable(find(cfg.tariffKey, cfg.tariffFallback));
      }

      // 🔥 Process second API response for parking bays
      if (secondApiResponse?.success && secondApiResponse?.data) {
        setParkingBaysData(secondApiResponse.data);
      } else {
        console.warn("Second API failed:", secondApiResponse?.message);
        setParkingBaysData(null);
      }
      
    } catch (err) {
      console.error('Fetch error:', err);
    }
  };

  // ── Auto-save ─────────────────────────────────────────────────────────
  const autoSave = () => {
    if (saveRef.current) clearTimeout(saveRef.current);
    saveRef.current = setTimeout(saveToAPI, API_CALL_TIME);
  };

  // ── Fixed saveToAPI using Refs ────────────────────────────────────────────
  const saveToAPI = async () => {
    try {
      setIsSaving(true);

      const tables = [
        { 
          table_key: profileRef.current?.table_key, 
          title: profileRef.current?.title, 
          data: profileRef.current?.data 
        },
        { 
          table_key: assetsRef.current?.table_key, 
          title: assetsRef.current?.title, 
          data: assetsRef.current?.data 
        },
      ];

      if (tariffRef.current) {
        tables.push({ 
          table_key: tariffRef.current.table_key, 
          title: tariffRef.current.title, 
          data: tariffRef.current.data 
        });
      }

      const res = await apiCall('POST', '/boardpack/add-tables-data', {
        contract, 
        year, 
        month: monthNumber, 
        created_by: 1, 
        tables,
      });

      if (!res?.success) throw new Error(res?.message || 'Save failed');
    } catch (err) {
      console.error('Save error:', err);
      toast.error('Failed to save changes');
    } finally {
      setIsSaving(false);
    }
  };

  // ── Patch helpers ─────────────────────────────────────────────────────
  const patchProfile = (field, subField, value) => {
    setProfileTable(prev => ({
      ...prev,
      data: { ...prev.data, [field]: subField ? { ...prev.data[field], [subField]: value } : value },
    }));
    autoSave();
  };

  const handleTariffCell = (rIdx, key, value) => {
    setTariffTable(prev => ({
      ...prev,
      data: { ...prev.data, rows: prev.data.rows.map((r, i) => i === rIdx ? { ...r, [key]: value } : r) },
    }));
    autoSave();
  };

  const handleAssetSubCount = (flatIdx, value) => {
    const flat = groupsToFlat(assetsRef.current?.data?.groups || []).map((a, i) => i === flatIdx ? { ...a, subCount: value } : a);
    setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
    autoSave();
  };

  const handleAssetTotalCount = (flatIdx, value) => {
    const flat = groupsToFlat(assetsRef.current?.data?.groups || []).map((a, i) => i === flatIdx ? { ...a, totalCount: value } : a);
    setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
    autoSave();
  };

  const pd         = profileTable.data;
  const flatAssets = groupsToFlat(assetsTable.data.groups);

  // ═══════════════════════════════════════════════════════════════════
  // RENDER
  // ═══════════════════════════════════════════════════════════════════
  return (
    <div className="min-h-screen p-8 bg-white">

      {/* ── Header ── */}
      <div className="flex justify-between items-center mb-3">
        <div className="ml-2">
          <img src={AlHassa} alt="Al Hassa Logo" style={{ height: '50px', objectFit: 'contain' }} />
        </div>
        <h1 className="text-xl font-bold flex-1 text-center">{profileTable.title}</h1>
      </div>

      <div className="flex flex-row gap-0 !border-2 !border-black p-3">

        {/* ══ LEFT ══ */}
        <div className="flex-1 pr-4">
          <div className="flex flex-col">

            {/* ── Activities ── */}
            <div className="mb-4">
              <div className="text-[16px] font-semibold mb-4">Activities:</div>
              <div className="flex gap-4 justify-start ml-16 ">
                {['On Street', 'Enforcement'].map(label => (
                  <div key={label} className="flex flex-col items-center gap-2 ">
                    {label === 'On Street' && <img src={OnStreet} alt="On Street" style={{ height: '150px', objectFit: 'contain' }} />}
                    {label === 'Enforcement' && <img src={Enforcement} alt="Enforcement" style={{ height: '150px', objectFit: 'contain' }} />}
                  </div>
                ))}
              </div>
            </div>

            {/* ── Profile Info ── */}
            <div className="flex flex-col gap-1 mb-2">

              {/* 🔥 READ-ONLY Total Bays */}
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 rounded flex items-center justify-center text-[8px] text-gray-400" />
                <img src={OnStreet} alt="On Street" style={{ height: '50px', objectFit: 'contain' }} />
                <span className="text-[12px]">
                  {pd.total_bays?.label}{' '}
                  <strong>
                    <input 
                      type="text" 
                      value={effectiveTotalBays}
                      readOnly 
                      disabled
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-20 cursor-default" 
                    />
                  </strong>
                </span>
              </div>

              {/* Contract Term - Editable */}
              <div className="flex items-center gap-2 ml-20">
                <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                <span className="text-[12px] flex items-center flex-wrap gap-1">
                  Contract term{' '}
                  <strong><input type="text" value={pd.contract_term?.value || ''}
                    onChange={e => patchProfile('contract_term', 'value', e.target.value)}
                    className="font-bold outline-none bg-transparent !border-0 text-[12px] w-12" /></strong>
                  ; start date{' '}
                  <strong><input type="text" value={pd.contract_period?.start_date || ''}
                    onChange={e => patchProfile('contract_period', 'start_date', e.target.value)}
                    className="font-bold outline-none bg-transparent !border-0 text-[12px] w-18" /></strong>
                  {' to '}
                  <strong><input type="text" value={pd.contract_period?.end_date || ''}
                    onChange={e => patchProfile('contract_period', 'end_date', e.target.value)}
                    className="font-bold outline-none bg-transparent !border-0 text-[12px] w-24" /></strong>
                </span>
              </div>

              {/* Rate Per Hour - Editable */}
              <div className="flex items-center gap-2 ml-20">
                <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                <span className="text-[12px]">
                  Rate per Hour{' '}
                  <strong>
                    <input type="text" value={pd.rate_per_hour?.value || ''}
                      onChange={e => patchProfile('rate_per_hour', 'value', e.target.value)}
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-48" />
                  </strong>
                </span>
              </div>

              {/* Assets Deployed */}
              <div className="flex items-center gap-2 ml-20">
                <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
                <span className="text-[12px]">Assets Deployed</span>
              </div>
            </div>

          </div>

          {/* ── Tariff Table - Editable ── */}
          {tariffTable && (
            <div className="mt-2">
              <table className="!border-collapse text-[8px]">
                <thead>
                  <tr>
                    <th colSpan={5} className="!border !border-black px-2 py-1.5 bg-gray-300 text-center font-bold text-[11px]">
                      {tariffTable.title}
                    </th>
                  </tr>
                  <tr className="bg-gray-300">
                    {[
                      { label: 'Product',      w: '180px' },
                      { label: 'Vehicle Type', w: '80px'  },
                      { label: 'Tariff',       w: '60px'  },
                      { label: 'Timing',       w: '150px' },
                      { label: 'Working Days', w: '90px'  },
                    ].map(({ label, w }) => (
                      <th key={label} className="!border !border-black px-2 py-1 font-bold text-center" style={{ minWidth: w }}>
                        {label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {tariffTable.data.rows.map((row, rIdx) => (
                    <tr key={rIdx} className={rIdx % 2 === 0 ? 'bg-white' : ''}>
                      {[
                        { key: 'product',      w: '180px' },
                        { key: 'vehicle_type', w: '80px'  },
                        { key: 'tariff',       w: '60px'  },
                        { key: 'timing',       w: '150px' },
                        { key: 'working_days', w: '90px'  },
                      ].map(({ key, w }) => (
                        <td key={key} className="!border !border-black px-1 py-0.5">
                          <textarea
                            value={row[key] || ''}
                            onChange={e => handleTariffCell(rIdx, key, e.target.value)}
                            className="!border-0 bg-transparent outline-none text-[9px] content-center resize-none text-center"
                            style={{ width: w, minHeight: '30px' }}
                            rows={2}
                          />
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {/* ══ RIGHT — Assets Panel ══ */}
        <AssetsPanel
          assetsTable={assetsTable}
          flatAssets={flatAssets}
          onSubCount={handleAssetSubCount}
          onTotalCount={handleAssetTotalCount}
        />
      </div>
    </div>
  );
};

export default AlHassaProfile;